module.exports = __webpack_public_path__ + "static/media/ic_share.22de682b.svg";